<template>

  <div>

    <ref-category-list-add-new
      :is-add-new-ref-category-sidebar-active.sync="isAddNewRefCategorySidebarActive"
      :role-options="roleOptions"
      :plan-options="planOptions"
      :category="refCategory"
      @refetch-data="refetchData"
      @add-ref-category="addRefCategory"
      @update-ref-category="updateRefCategory"
      :clear-ref-category-data="resetRefCategoryData"
      :ref-category-options="refCategoryOptions"
    />
    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Нэг хуудсанд</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label> бичлэг харуулах</label>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Хайх..."
              />
              <b-button
                variant="primary"
                @click="isAddNewRefCategorySidebarActive = true"
              >
                <span class="text-nowrap">Ангилал нэмэх</span>
              </b-button>
            </div>
          </b-col>
        </b-row>

      </div>
      <el-table
        :data="refCategoryOptions"
        style="width: 100%;margin-bottom: 20px;"
        row-key="id"
        border
        default-expand-all>
        <el-table-column
          prop="name"
          label="Ангилалын нэр"
          sortable
          >
        </el-table-column>
        <el-table-column
          prop="created_at"
          label="Үүсгэсэн огноо"
          sortable>
        </el-table-column>
        <el-table-column
          prop="created_by"
          label="Үүсгэсэн хэрэглэгч"
          sortable>
        </el-table-column>
        <el-table-column
          prop="is_active"
          label="Төлөв">
          <template slot-scope="scope">
            <b-badge
              pill
              :variant="scope.row.is_active ? 'success': 'danger'"
            >
              {{ scope.row.is_active ? 'идэвхтэй': 'идэвхгүй' }}
            </b-badge>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="Үйлдэл"
          width="180">
          <template slot-scope="scope">
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="outline-primary"
              class="btn-icon __table_action_button"
              @click="getCategory(scope.row)" v-b-tooltip.hover.v-primary title="Дэлгэрэнгүй"
              size="sm"
            >
              <feather-icon icon="FileTextIcon" />
            </b-button>
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="outline-primary"
              class="btn-icon __table_action_button"
              @click="getCategory(scope.row)" v-b-tooltip.hover.v-primary title="Засах"
              size="sm"
            >
              <feather-icon icon="EditIcon" />
            </b-button>
            <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            :variant="scope.row.is_active ? 'outline-primary' : 'primary'"
            class="btn-icon __table_action_button"
            @click="confirmDelete(scope.row)" v-b-tooltip.hover.v-primary :title="'Устгах'"
            size="sm"
          >
            <feather-icon :icon="'TrashIcon'" />
          </b-button>
          </template>
        </el-table-column>
      </el-table>
      <b-modal id="delete-confirm-modal" @ok="deleteRefCategory" ok-title="Тийм"
      cancel-title="Үгүй">
        <template #modal-title>
          Устгахдаа итгэлтэй байна уу?
        </template>
        <p>Та энэ үүргийг устгахдаа итгэлтэй байна уу?</p>
      </b-modal>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Нийт {{ dataMeta.of }}-н {{ dataMeta.from }} - {{ dataMeta.to }} бичлэгийг  харуулж байна</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalOrganizations"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination, VBTooltip,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import { ref, onUnmounted } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import RefCategoriesListFilters from './RefCategoriesListFilters.vue'
import useRefCategoriesList from './useRefCategoriesList'
import refCategoryStoreModule from '../refCategoryStoreModule'
import RefCategoryListAddNew from './RefCategoryListAddNew.vue'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    RefCategoriesListFilters,
    RefCategoryListAddNew,

    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,

    vSelect,
  },
  directives: {
        'b-tooltip': VBTooltip,
        Ripple,
    },
  setup() {
    const toast = useToast()
    const REF_CATEGORY_APP_STORE_MODULE_NAME = 'app-ref-category'

    // Register module
    if (!store.hasModule(REF_CATEGORY_APP_STORE_MODULE_NAME)) store.registerModule(REF_CATEGORY_APP_STORE_MODULE_NAME, refCategoryStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(REF_CATEGORY_APP_STORE_MODULE_NAME)) store.unregisterModule(REF_CATEGORY_APP_STORE_MODULE_NAME)
    })

    const isAddNewRefCategorySidebarActive = ref(false)

    const blankRefCategory = {
      parent: null,
      name: '',
      sort_order: '',
    }

    const refCategory = ref(JSON.parse(JSON.stringify(blankRefCategory)))
    const resetRefCategoryData = () => {
      refCategory.value = JSON.parse(JSON.stringify(blankRefCategory))
    }
    const roleOptions = [
      { label: 'Админ', value: 'admin' },
      { label: 'Эрхлэгч', value: 'author' },
      { label: 'Засварлагч', value: 'editor' },
      { label: 'Дэмжигч', value: 'maintainer' },
      { label: 'Дагагч', value: 'subscriber' },
    ]

    const planOptions = [
      { label: 'Үндсэн', value: 'basic' },
      { label: 'Дэд', value: 'company1' },
      { label: 'Аж ахуй нэгж', value: 'enterprise' },
      { label: 'Баг', value: 'team' },
    ]

    const statusOptions = [
      // { label: 'Хүлээгдэж буй', value: 'pending' },
      { label: 'Идэвхитэй', value: 'true' },
      { label: 'Идэвхигүй', value: 'false' },
    ]

    const refCategoryOptions = ref([]);

    const fetchRefCategoryWithChildren = val => {
      console.log('val', val)
      store.dispatch('app-ref-category/fetchRefCategoriesWithChildren', val)
        .then(response => {
          refCategoryOptions.value = response.data.response
          // eslint-disable-next-line no-use-before-define
          // fetchRefPriorities()
        })
    }
    fetchRefCategoryWithChildren()

    const addRefCategory = val => {
      console.log('val', val)
      store.dispatch('app-ref-category/addRefCategory', val)
        .then(response => {
          if (response.data.success) {
            toast({
              component: ToastificationContent,
              props: {
                title: "Амжиллтай нэмлээ.",
                icon: 'BellIcon',
                variant: 'success',
              },
            },
            {
              position: 'bottom-right'
            })
            setTimeout(() => {
              fetchRefCategoryWithChildren() // Refresh the current route
            }, 1000) 
          } else {
            toast({
              component: ToastificationContent,
              props: {
                title: 'Алдаа гарлаа',
                icon: 'BellIcon',
                variant: 'danger',
              },
            })
          }
        })
    }

    const updateRefCategory = val => {
      store.dispatch('app-ref-category/editRefCategory', val)
        .then(() => {
          // eslint-disable-next-line no-use-before-define
          fetchRefCategoryWithChildren()
        })
    }
    
    // const removeRefCategory = () => {
    //   store.dispatch('app-todo/removeTask', { id: task.value.id })
    //     .then(() => {
    //       // eslint-disable-next-line no-use-before-define
    //       fetchTasks()
    //     })
    // }

    const getCategory = catgoryData => {
      console.log(catgoryData)
      refCategory.value = catgoryData
      isAddNewRefCategorySidebarActive.value = true
    }

    const {
      fetchRefCategories,
      tableColumns,
      perPage,
      currentPage,
      totalOrganizations,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refRefCategoryListTable,
      refetchData,

      // UI
      resolveOrganizationRoleVariant,
      resolveOrganizationRoleIcon,
      resolveOrganizationStatusVariant,
      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,
    } = useRefCategoriesList()

    

    return {

      // Sidebar
      isAddNewRefCategorySidebarActive,

      fetchRefCategories,
      fetchRefCategoryWithChildren,
      tableColumns,
      perPage,
      currentPage,
      totalOrganizations,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refRefCategoryListTable,
      refetchData,

      addRefCategory,
      updateRefCategory,

      // getPriority,
      resetRefCategoryData,
      refCategory,
      getCategory,

      // Filter
      avatarText,

      // UI
      resolveOrganizationRoleVariant,
      resolveOrganizationRoleIcon,
      resolveOrganizationStatusVariant,

      roleOptions,
      planOptions,
      statusOptions,
      refCategoryOptions,

      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,
    }
  },
  data() {
      return {
        tableData: [{
          id: 1,
          date: '2016-05-02',
          name: 'wangxiaohu'
        }, {
          id: 2,
          date: '2016-05-04',
          name: 'wangxiaohu'
        }, {
          id: 3,
          date: '2016-05-01',
          name: 'wangxiaohu',
          children: [{
              id: 31,
              date: '2016-05-01',
              name: 'wangxiaohu'
            }, {
              id: 32,
              date: '2016-05-01',
              name: 'wangxiaohu'
          }]
        }, {
          id: 4,
          date: '2016-05-03',
          name: 'wangxiaohu'
        }]
      }
    },
  methods: {
    confirmDelete(refCategoryData) {
      this.refCategoryData = refCategoryData;
      this.$bvModal.show('delete-confirm-modal');
    },
    deleteRefCategory () {
      if(this.refCategoryData){
        store.dispatch('app-ref-category/deleteRefCategory', this.refCategoryData)
        .then(response => {
          console.log(response)
          if (response.data.success) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message,
                icon: 'BellIcon',
                variant: 'success',
              },
            })
            setTimeout(() => {
              this.$router.go()  // Refresh the current route
            }, 1000) 
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Алдаа гарлаа',
                icon: 'BellIcon',
                variant: 'danger',
              },
            })
          }
        })
        .finally(() => {
          this.refCategoryData = null; // Reset the organization after deletion
        });
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
.__table_action_button {
  margin-right: 5px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
